import { ApiClient, CruiseApi, ICruise, ICruisesResponse } from "../../Types"

export const CruiseCalendarViewData = {
  loadCruises(api: ApiClient, shipId: number): Promise<ICruisesResponse> {
    return new CruiseApi(api).cruises.list({ params: { shipId } }).call();
  },
  // On a cloud session only cruises that have actually started are shown; locally
  // every cruise is kept. The result is sorted ascending by start date (an undefined
  // start sorts as "now").
  sortCruises(cruises: ICruise[] | undefined, cloudSession: boolean): ICruise[] {
    return (cruises || [])
      .filter((cruise) => (cloudSession ? cruise.startedAt !== undefined : true))
      .toSorted(
        (a, b) =>
          (a.startedAt ? new Date(Date.parse(a.startedAt)) : new Date()).valueOf() -
          (b.startedAt ? new Date(Date.parse(b.startedAt)) : new Date()).valueOf(),
      );
  },
  // The [minYear, maxYear] span the calendar grid must cover. Empty -> the current
  // year for both ends; an unparseable first start falls back to the max year.
  yearRange(sortedCruises: ICruise[], today: string): [number, number] {
    const range = (
      sortedCruises.length > 0
        ? [sortedCruises[0].startedAt!, sortedCruises[sortedCruises.length - 1].completedAt || today]
        : [today, today]
    ).map((d) => new Date(Date.parse(d)).getFullYear()) as [number, number];
    if (isNaN(range[0])) {
      range[0] = range[1];
    }
    return range;
  },
};
